import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAuthHeaders = () => {
    const token = localStorage.getItem('savistones_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  const checkAuth = async () => {
    const token = localStorage.getItem('savistones_token');
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const response = await axios.get(`${BACKEND_URL}/api/auth/me`, {
        headers: getAuthHeaders(),
        withCredentials: true
      });
      setUser(response.data);
    } catch (error) {
      localStorage.removeItem('savistones_token');
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const response = await axios.post(
      `${BACKEND_URL}/api/auth/login`,
      { email, password },
      { withCredentials: true }
    );
    const data = response.data;
    if (data.token) {
      localStorage.setItem('savistones_token', data.token);
    }
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await axios.post(`${BACKEND_URL}/api/auth/logout`, {}, {
        headers: getAuthHeaders(),
        withCredentials: true
      });
    } catch (e) {}
    localStorage.removeItem('savistones_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, checkAuth, getAuthHeaders }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
